export default __webpack_public_path__ + "static/media/codewars.ae70542f.svg";